module.exports = __webpack_public_path__ + "static/assets/fa6486f0970e714774232642924b845e.gif";